module.exports = __webpack_public_path__ + "static/media/UnionSimp.52b0f9f0.svg";